import type { ModelDefinition } from "@/models.js";

export const bytedanceModels = [
	{
		id: "seed-1-6-250615",
		name: "Seed 1.6 (250615)",
		description:
			"ByteDance Seed 1.6 vision model with thinking/non-thinking modes, multimodal inputs, and 256K context window",
		family: "bytedance",
		releasedAt: new Date("2025-06-25"),
		providers: [
			{
				providerId: "bytedance",
				externalId: "seed-1-6-250615",
				inputPrice: "0.25e-6",
				outputPrice: "2e-6",
				cachedInputPrice: "0.05e-6",
				requestPrice: "0",
				contextSize: 256000,
				maxOutput: undefined,
				streaming: true,
				reasoning: true,
				reasoningEfforts: ["minimal", "low", "medium", "high"],
				vision: true,
				tools: true,
				jsonOutput: true,
			},
		],
	},
	{
		id: "seed-1-6-250915",
		name: "Seed 1.6 (250915)",
		description:
			"ByteDance Seed 1.6 vision model released September 15, 2025 with thinking/non-thinking modes and multimodal inputs",
		family: "bytedance",
		releasedAt: new Date("2025-09-15"),
		providers: [
			{
				providerId: "bytedance",
				externalId: "seed-1-6-250915",
				inputPrice: "0.25e-6",
				cachedInputPrice: "0.05e-6",
				outputPrice: "2e-6",
				requestPrice: "0",
				contextSize: 256000,
				maxOutput: undefined,
				streaming: true,
				reasoning: true,
				reasoningEfforts: ["minimal", "low", "medium", "high"],
				vision: true,
				tools: true,
				jsonOutput: true,
			},
		],
	},
	{
		id: "seed-1-6-flash-250715",
		name: "Seed 1.6 Flash (250715)",
		description:
			"ByteDance Seed 1.6 Flash - faster, cost-effective vision model released July 15, 2025",
		family: "bytedance",
		releasedAt: new Date("2025-07-26"),
		providers: [
			{
				providerId: "bytedance",
				externalId: "seed-1-6-flash-250715",
				inputPrice: "0.07e-6",
				cachedInputPrice: "0.015e-6",
				outputPrice: "0.3e-6",
				requestPrice: "0",
				contextSize: 256000,
				maxOutput: undefined,
				streaming: true,
				reasoning: true,
				reasoningEfforts: ["minimal", "low", "medium", "high"],
				vision: true,
				tools: true,
				jsonOutput: true,
			},
		],
	},
	{
		id: "seed-1-8-251228",
		name: "Seed 1.8 (251228)",
		description:
			"ByteDance Seed 1.8 advanced vision model released December 28, 2025 with enhanced capabilities",
		family: "bytedance",
		releasedAt: new Date("2025-12-18"),
		providers: [
			{
				providerId: "bytedance",
				externalId: "seed-1-8-251228",
				inputPrice: "0.25e-6",
				cachedInputPrice: "0.05e-6",
				outputPrice: "2e-6",
				requestPrice: "0",
				contextSize: 256000,
				maxOutput: undefined,
				streaming: true,
				reasoning: true,
				reasoningEfforts: ["minimal", "low", "medium", "high"],
				vision: true,
				tools: true,
				jsonOutput: true,
			},
		],
	},
	{
		id: "seed-2-1-turbo",
		name: "Seed 2.1 Turbo",
		description:
			"ByteDance Seed 2.1 Turbo multimodal model built for coding and long-horizon agent workflows with a 256K context window",
		family: "bytedance",
		releasedAt: new Date("2026-08-10"),
		providers: [],
	},
	{
		id: "seedream-4-0",
		name: "Seedream 4.0",
		description:
			"ByteDance Seedream 4.0 text-to-image generation model with high-quality visual output",
		family: "bytedance",
		output: ["text", "image"],
		releasedAt: new Date("2025-09-16"),
		providers: [
			{
				test: "skip",
				providerId: "bytedance",
				externalId: "seedream-4-0-250828",
				inputPrice: "0",
				outputPrice: "0",
				requestPrice: "0.035",
				contextSize: 2000,
				maxOutput: 4096,
				streaming: false,
				vision: false,
				tools: false,
				jsonOutput: false,
				imageGenerations: true,
			},
		],
	},
	{
		id: "seedance-2-5",
		name: "Seedance 2.5",
		description:
			"ByteDance Seedance 2.5 video generation model with single-shot clips up to 30 seconds and omni-reference image/video/audio conditioning",
		family: "bytedance",
		output: ["video"],
		maxVideoDurationSeconds: 30,
		releasedAt: new Date("2026-08-08"),
		providers: [
			{
				test: "skip",
				providerId: "bytedance",
				externalId: "dreamina-seedance-2-5-260628",
				videoOutputPrice: {
					default_without_video: "10.7e-6",
					default_with_video: "6.4e-6",
					"1080p_without_video": "11.7e-6",
					"1080p_with_video": "7e-6",
				},
				inputPrice: undefined,
				outputPrice: undefined,
				requestPrice: undefined,
				perSecondPrice: {
					default_audio: "0.23112",
					default_video: "0.23112",
					"480p_audio": "0.10280025",
					"480p_video": "0.10280025",
					"1080p_audio": "0.56862",
					"1080p_video": "0.56862",
				},
				contextSize: 2000,
				maxOutput: 1,
				streaming: false,
				vision: false,
				tools: false,
				jsonOutput: false,
				videoGenerations: true,
				supportedVideoSizes: [
					"848x480",
					"854x480",
					"480x854",
					"1280x720",
					"720x1280",
					"1920x1080",
					"1080x1920",
				],
				supportedVideoDurationsSeconds: [
					4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
					23, 24, 25, 26, 27, 28, 29, 30,
				],
				supportsVideoAudio: true,
				supportsVideoWithoutAudio: true,
			},
		],
	},
	{
		id: "seedance-2-0",
		name: "Seedance 2.0",
		description:
			"ByteDance Seedance 2.0 high-quality video generation model with text-to-video and image-to-video support",
		family: "bytedance",
		output: ["video"],
		releasedAt: new Date("2026-04-14"),
		providers: [
			{
				test: "skip",
				providerId: "bytedance",
				externalId: "dreamina-seedance-2-0-260128",
				videoOutputPrice: {
					default_without_video: "7e-6",
					default_with_video: "4.3e-6",
					"1080p_without_video": "7.7e-6",
					"1080p_with_video": "4.7e-6",
					"4k_without_video": "4e-6",
					"4k_with_video": "2.4e-6",
				},
				inputPrice: undefined,
				outputPrice: undefined,
				requestPrice: undefined,
				perSecondPrice: {
					default_audio: "0.1512",
					default_video: "0.1512",
					"1080p_audio": "0.37422",
					"1080p_video": "0.37422",
				},
				contextSize: 2000,
				maxOutput: 1,
				streaming: false,
				vision: false,
				tools: false,
				jsonOutput: false,
				videoGenerations: true,
				supportedVideoSizes: ["1280x720", "720x1280", "1920x1080", "1080x1920"],
				supportedVideoDurationsSeconds: [
					4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
				],
				supportsVideoAudio: true,
				supportsVideoWithoutAudio: true,
			},
		],
	},
	{
		id: "seedance-2-0-fast",
		name: "Seedance 2.0 Fast",
		description:
			"ByteDance Seedance 2.0 Fast - accelerated video generation model for quicker outputs",
		family: "bytedance",
		output: ["video"],
		releasedAt: new Date("2026-04-14"),
		providers: [
			{
				test: "skip",
				providerId: "bytedance",
				externalId: "dreamina-seedance-2-0-fast-260128",
				videoOutputPrice: {
					default_without_video: "5.6e-6",
					default_with_video: "3.3e-6",
				},
				inputPrice: undefined,
				outputPrice: undefined,
				requestPrice: undefined,
				perSecondPrice: {
					default_audio: "0.12096",
					default_video: "0.12096",
				},
				contextSize: 2000,
				maxOutput: 1,
				streaming: false,
				vision: false,
				tools: false,
				jsonOutput: false,
				videoGenerations: true,
				supportedVideoSizes: ["1280x720", "720x1280"],
				supportedVideoDurationsSeconds: [
					4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
				],
				supportsVideoAudio: true,
				supportsVideoWithoutAudio: true,
			},
		],
	},
	{
		id: "seedance-2-0-mini",
		name: "Seedance 2.0 Mini",
		description:
			"ByteDance Seedance 2.0 Mini - lightweight and highly efficient video generation model designed for rapid iteration",
		family: "bytedance",
		output: ["video"],
		releasedAt: new Date("2026-06-15"),
		providers: [
			{
				test: "skip",
				providerId: "bytedance",
				externalId: "dreamina-seedance-2-0-mini-260615",
				videoOutputPrice: {
					default_without_video: "3.5e-6",
					default_with_video: "2.1e-6",
				},
				inputPrice: undefined,
				outputPrice: undefined,
				requestPrice: undefined,
				perSecondPrice: {
					default_audio: "0.0756",
					default_video: "0.0756",
					"480p_audio": "0.035154",
					"480p_video": "0.035154",
				},
				contextSize: 2000,
				maxOutput: 1,
				streaming: false,
				vision: false,
				tools: false,
				jsonOutput: false,
				videoGenerations: true,
				supportedVideoSizes: [
					"1280x720",
					"720x1280",
					"848x480",
					"854x480",
					"480x854",
				],
				supportedVideoDurationsSeconds: [
					4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
				],
				supportsVideoAudio: true,
				supportsVideoWithoutAudio: true,
			},
		],
	},
	{
		id: "seedance-1-5-pro",
		name: "Seedance 1.5 Pro",
		description:
			"ByteDance Seedance 1.5 Pro - professional video generation model with complex instruction following and native audio",
		family: "bytedance",
		output: ["video"],
		releasedAt: new Date("2026-03-23"),
		providers: [
			{
				test: "skip",
				providerId: "bytedance",
				externalId: "seedance-1-5-pro-251215",
				deactivatedAt: new Date("2026-11-11"),
				videoOutputPrice: {
					default_audio: "2.4e-6",
					default_video: "1.2e-6",
				},
				inputPrice: undefined,
				outputPrice: undefined,
				requestPrice: undefined,
				perSecondPrice: {
					default_audio: "0.05184",
					default_video: "0.02592",
					"1080p_audio": "0.11664",
					"1080p_video": "0.05832",
				},
				contextSize: 2000,
				maxOutput: 1,
				streaming: false,
				vision: false,
				tools: false,
				jsonOutput: false,
				videoGenerations: true,
				supportedVideoSizes: ["1280x720", "720x1280", "1920x1080", "1080x1920"],
				supportedVideoDurationsSeconds: [5, 10],
				supportsVideoAudio: true,
				supportsVideoWithoutAudio: true,
			},
		],
	},
	{
		id: "seedream-4-5",
		name: "Seedream 4.5",
		description:
			"ByteDance Seedream 4.5 advanced text-to-image generation model with enhanced quality and consistency",
		family: "bytedance",
		output: ["text", "image"],
		releasedAt: new Date("2025-12-03"),
		providers: [
			{
				test: "skip",
				providerId: "bytedance",
				externalId: "seedream-4-5-251128",
				inputPrice: "0",
				outputPrice: "0",
				requestPrice: "0.045",
				contextSize: 2000,
				maxOutput: 4096,
				streaming: false,
				vision: false,
				tools: false,
				jsonOutput: false,
				imageGenerations: true,
			},
		],
	},
	{
		id: "seedream-5-0-lite",
		name: "Seedream 5.0 Lite",
		description:
			"ByteDance Seedream 5.0 Lite (Dola Seedream 5.0) text-to-image generation model with strong prompt understanding and up to 4K output",
		family: "bytedance",
		output: ["text", "image"],
		releasedAt: new Date("2026-01-28"),
		providers: [
			{
				test: "skip",
				providerId: "bytedance",
				externalId: "seedream-5-0-260128",
				inputPrice: "0",
				outputPrice: "0",
				requestPrice: "0.035",
				contextSize: 2000,
				maxOutput: 4096,
				streaming: false,
				vision: false,
				tools: false,
				jsonOutput: false,
				imageGenerations: true,
			},
		],
	},
	{
		id: "seedream-5-0-pro",
		name: "Seedream 5.0 Pro",
		description:
			"ByteDance Seedream 5.0 Pro flagship image generation and editing model with precise layout control, multilingual text rendering, and up to 2K output",
		family: "bytedance",
		output: ["text", "image"],
		releasedAt: new Date("2026-06-28"),
		providers: [
			{
				test: "skip",
				providerId: "bytedance",
				externalId: "dola-seedream-5-0-pro-260628",
				inputPrice: "0",
				outputPrice: "0",
				requestPrice: "0.09",
				contextSize: 2000,
				maxOutput: 4096,
				streaming: false,
				vision: true,
				tools: false,
				jsonOutput: false,
				imageGenerations: true,
			},
		],
	},
	{
		id: "seedream-5-0-flash",
		name: "Seedream 5.0 Flash",
		description:
			"ByteDance Seedream 5.0 Flash fast, cost-efficient image generation and editing model for high-volume and interactive workflows, with up to 2K output",
		family: "bytedance",
		output: ["text", "image"],
		releasedAt: new Date("2026-09-15"),
		providers: [
			{
				test: "skip",
				providerId: "bytedance",
				externalId: "dola-seedream-5-0-flash-260915",
				inputPrice: "0",
				outputPrice: "0",
				requestPrice: "0.018",
				contextSize: 2000,
				maxOutput: 4096,
				streaming: false,
				vision: true,
				tools: false,
				jsonOutput: false,
				imageGenerations: true,
			},
		],
	},
	{
		id: "seed-2-0-pro-260328",
		name: "Seed 2.0 Pro (260328)",
		description:
			"ByteDance Seed 2.0 flagship multimodal reasoning model for complex agentic and enterprise tasks.",
		family: "bytedance",
		releasedAt: new Date("2026-03-28"),
		providers: [
			{
				providerId: "bytedance",
				externalId: "seed-2-0-pro-260328",
				inputPrice: "0.5e-6",
				cachedInputPrice: "0.1e-6",
				outputPrice: "3e-6",
				pricingTiers: [
					{
						name: "Up to 128K",
						upToTokens: 131072,
						inputPrice: "0.5e-6",
						outputPrice: "3e-6",
						cachedInputPrice: "0.1e-6",
					},
					{
						name: "Over 128K",
						upToTokens: Infinity,
						inputPrice: "1e-6",
						outputPrice: "6e-6",
						cachedInputPrice: "0.2e-6",
					},
				],
				requestPrice: "0",
				contextSize: 262144,
				maxOutput: 131072,
				minCacheableTokens: 2048,
				streaming: true,
				reasoning: true,
				reasoningEfforts: ["minimal", "low", "medium", "high"],
				vision: true,
				tools: true,
				jsonOutput: true,
				jsonOutputSchema: true,
			},
		],
	},
	{
		id: "seed-2-0-lite-260428",
		name: "Seed 2.0 Lite (260428)",
		description:
			"Cost-efficient ByteDance Seed 2.0 workhorse with strong multimodal and agent capabilities at lower latency.",
		family: "bytedance",
		releasedAt: new Date("2026-04-28"),
		providers: [
			{
				providerId: "bytedance",
				externalId: "seed-2-0-lite-260428",
				inputPrice: "0.25e-6",
				cachedInputPrice: "0.05e-6",
				outputPrice: "2e-6",
				pricingTiers: [
					{
						name: "Up to 128K",
						upToTokens: 131072,
						inputPrice: "0.25e-6",
						outputPrice: "2e-6",
						cachedInputPrice: "0.05e-6",
					},
					{
						name: "Over 128K",
						upToTokens: Infinity,
						inputPrice: "0.5e-6",
						outputPrice: "4e-6",
						cachedInputPrice: "0.1e-6",
					},
				],
				requestPrice: "0",
				contextSize: 262144,
				maxOutput: 131072,
				minCacheableTokens: 2048,
				streaming: true,
				reasoning: true,
				reasoningEfforts: ["minimal", "low", "medium", "high"],
				vision: true,
				tools: true,
				jsonOutput: true,
				jsonOutputSchema: true,
			},
		],
	},
	{
		id: "seed-2-0-mini-260428",
		name: "Seed 2.0 Mini (260428)",
		description:
			"ByteDance Seed 2.0 model for latency-sensitive, high-concurrency, cost-sensitive workloads.",
		family: "bytedance",
		releasedAt: new Date("2026-04-28"),
		providers: [
			{
				providerId: "bytedance",
				externalId: "seed-2-0-mini-260428",
				inputPrice: "0.1e-6",
				cachedInputPrice: "0.02e-6",
				outputPrice: "0.4e-6",
				pricingTiers: [
					{
						name: "Up to 128K",
						upToTokens: 131072,
						inputPrice: "0.1e-6",
						outputPrice: "0.4e-6",
						cachedInputPrice: "0.02e-6",
					},
					{
						name: "Over 128K",
						upToTokens: Infinity,
						inputPrice: "0.2e-6",
						outputPrice: "0.8e-6",
						cachedInputPrice: "0.04e-6",
					},
				],
				requestPrice: "0",
				contextSize: 262144,
				maxOutput: 131072,
				minCacheableTokens: 2048,
				streaming: true,
				reasoning: true,
				reasoningEfforts: ["minimal", "low", "medium", "high"],
				vision: true,
				tools: true,
				jsonOutput: true,
				jsonOutputSchema: true,
			},
		],
	},
	{
		id: "seed-2-0-code-preview-260328",
		name: "Seed 2.0 Code Preview (260328)",
		description:
			"ByteDance Seed 2.0 model optimized for agentic coding, frontend development, and multilingual programming.",
		family: "bytedance",
		releasedAt: new Date("2026-03-28"),
		providers: [
			{
				providerId: "bytedance",
				externalId: "seed-2-0-code-preview-260328",
				inputPrice: "0.5e-6",
				cachedInputPrice: "0.1e-6",
				outputPrice: "3e-6",
				pricingTiers: [
					{
						name: "Up to 128K",
						upToTokens: 131072,
						inputPrice: "0.5e-6",
						outputPrice: "3e-6",
						cachedInputPrice: "0.1e-6",
					},
					{
						name: "Over 128K",
						upToTokens: Infinity,
						inputPrice: "1e-6",
						outputPrice: "6e-6",
						cachedInputPrice: "0.2e-6",
					},
				],
				requestPrice: "0",
				contextSize: 262144,
				maxOutput: 131072,
				minCacheableTokens: 2048,
				streaming: true,
				reasoning: true,
				reasoningEfforts: ["minimal", "low", "medium", "high"],
				vision: true,
				tools: true,
				supportedToolChoices: ["auto", "none"],
				jsonOutput: false,
			},
		],
	},
] as const satisfies ModelDefinition[];
